import { Component, ElementRef, HostBinding, inject, OnInit } from '@angular/core';

@Component({
  selector: 'shared-core-table-header',
  template: ` <ng-content /> `,
})
export class TableHeaderRowComponent implements OnInit {
  @HostBinding('class')
  class = 'contents';

  private readonly elementRef = inject(ElementRef);
  element!: HTMLElement;

  ngOnInit() {
    this.element = this.elementRef.nativeElement;
  }
}
